import { useState } from 'react';
import { copyText } from './format';
import { Icon } from './Icon';

/**
 * Opens the phone's share sheet (Messages, Facebook, Nextdoor...) where there is one, and copies
 * the link everywhere else. Returns 'copied' when it fell back to copying.
 */
export async function shareLink(title: string, url: string): Promise<'shared' | 'copied' | 'cancelled'> {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ title, url });
      return 'shared';
    } catch (err) {
      // The seller closed the sheet; anything else (not allowed here) falls back to copying.
      if (err instanceof DOMException && err.name === 'AbortError') return 'cancelled';
    }
  }
  await copyText(url);
  return 'copied';
}

export function ShareButton({ title, url, label = 'Share', className = 'btn' }: { title: string; url: string; label?: string; className?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className={className}
      onClick={async () => {
        if ((await shareLink(title, url)) === 'copied') {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        }
      }}
    >
      <Icon name={copied ? 'check' : 'share'} size={20} /> <span>{copied ? 'Link copied' : label}</span>
    </button>
  );
}

/** The public address of a sale, or of one item in it. */
export function publicUrl(slug: string, itemNumber?: number): string {
  return `${window.location.origin}/${slug}${itemNumber === undefined ? '' : `/item/${itemNumber}`}`;
}
